import {RepoIcon, CommentDiscussionIcon} from '@primer/octicons-react'

import {Link} from '@primer/react'

import type {McpDetails} from '../../../../types'

import {About} from '../About/About'

import styles from './Sidebar.module.css'

type Props = {
  mcp: McpDetails
}

export function Sidebar({mcp}: Props) {
  return (
    <aside className={styles.sidebar}>
      <div className={styles.onlyDesktop}>
        <h2 className="sr-only">About</h2>

        <About mcp={mcp} />
      </div>

      <div className={styles.sidebarStack}>
        <h2 className="h5">Resources</h2>

        <ul className={styles.resourceLinks}>
          {mcp.name_with_owner ? (
            <li>
              <Link href={`/${mcp.name_with_owner}`} muted className={styles.resourceLink}>
                <RepoIcon size={16} className={styles.repoIcon} />
                {mcp.name_with_owner.split('/').join(' / ')}
              </Link>
            </li>
          ) : null}

          <li>
            <Link href="https://support.github.com/" muted className={styles.resourceLink}>
              <CommentDiscussionIcon size={16} />
              Contact support
            </Link>
          </li>
        </ul>
      </div>
    </aside>
  )
}

try{ Sidebar.displayName ||= 'Sidebar' } catch {}